var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('header',[_vm._t("header",null,{"user":_vm.user})],2),_c('main',[_vm._t("default",null,{"age":_vm.age})],2),_c('footer',[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }